import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL;

export const apiClient = axios.create({
    baseURL: API_BASE,
    headers: {
        'Content-Type': 'application/json'
    }
});

// ✅ Attach token automatically
apiClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// ✅ Handle success/failure centrally
apiClient.interceptors.response.use(
    (response) => {
        const res = response.data;

        // If your FastAPI backend explicitly returns `success: false`, catch it here.
        // Otherwise, assume it's successful since it's a 2xx HTTP response!
        if (res.success === false) {
            return Promise.reject({
                message: res.message || "Request failed",
                data: res.data || null
            });
        }

        return response; // return the actual response format so .data works everywhere again
    },
    (error) => {
        const res = error.response?.data;
        const message =
            res?.message ||
            error.message ||
            "Something went wrong";

        if (error.response?.status === 403 && /blocked/i.test(message)) {
            localStorage.removeItem('token');
            if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }

        return Promise.reject({
            message,
            data: res?.data || null
        });
    }
);
